import { Invoice } from '../types';

export interface FaturaResumo {
  total: number;
  pagas: number;
  pendentes: number;
  vencidas: number;
  valorTotal: number;
  valorPendente: number;
  valorVencidas: number;
  valorPago: number;
  lastPayment?: string;
  nextDueDate?: string;
}

export const validateInvoiceNumericValue = (value: unknown): number => {
  if (value === null || value === undefined) return 0;
  const num = Number(value);
  return Number.isNaN(num) ? 0 : num;
};

/** Mesma lógica de cálculo usada na aba Financeiro do cliente. */
export function calculateFaturaResumo(invoices: Invoice[]): FaturaResumo {
  const resumo = invoices.reduce(
    (acc, fatura) => {
      acc.total++;

      const valorFatura = validateInvoiceNumericValue(fatura.valor);

      if (fatura.status !== 'cancelado') {
        acc.valorTotal += valorFatura;
      }

      if (fatura.status === 'pago') {
        acc.pagas++;
        acc.valorPago += valorFatura;
      } else if (fatura.status === 'vencido') {
        acc.vencidas++;
        acc.valorVencidas += valorFatura;
      } else if (fatura.status === 'aberto') {
        acc.pendentes++;
        acc.valorPendente += valorFatura;
      }

      return acc;
    },
    {
      total: 0,
      pagas: 0,
      pendentes: 0,
      vencidas: 0,
      valorTotal: 0,
      valorPendente: 0,
      valorVencidas: 0,
      valorPago: 0,
    }
  );

  const paidWithDate = invoices
    .filter((i) => i.status === 'pago' && i.data_pagamento)
    .sort((a, b) => new Date(b.data_pagamento!).getTime() - new Date(a.data_pagamento!).getTime());

  const parseDueDate = (dateString: string) => {
    if (!dateString) return 0;
    if (dateString.indexOf('T') === -1) {
      return new Date(`${dateString}T12:00:00`).getTime();
    }
    return new Date(dateString).getTime();
  };

  const upcomingInvoices = invoices
    .filter((i) => ['aberto', 'vencido', 'parcialmente_pago'].includes(i.status))
    .sort((a, b) => parseDueDate(a.data_vencimento) - parseDueDate(b.data_vencimento));

  return {
    ...resumo,
    lastPayment: paidWithDate.length > 0 ? paidWithDate[0].data_pagamento : undefined,
    nextDueDate: upcomingInvoices.length > 0 ? upcomingInvoices[0].data_vencimento : undefined,
  };
}

export function extractInvoicesFromResponse(response: unknown): Invoice[] {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (typeof response === 'object' && response !== null) {
    const apiResponse = response as { success?: boolean; data?: Invoice[] };
    if (apiResponse.data) return apiResponse.data;
  }
  return [];
}
